const Footer = () => {
  return (
    <footer>
      <div class="footer_container container flex-center">
        <p class="footer__rights">
          Copyright © 2021 Fabian Zieliński
          <a class="footer__link" href="">
            ` fz.pl
          </a>{" "}
          Wszelkie prawa zastrzeżone
        </p>
      </div>
    </footer>
  );
};

export default Footer;
